import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import { Popup } from 'semantic-ui-react';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

const StudentProgressBarWidget = observer((props = {}) => {
  const { onlyRenderInnerWidgetContent, t } = props;

  const {
    appManager, classroomManager, studentProgressManager, userManager
  } = useContext(MobXProviderContext);

  // Set default loading value when not provided
  const loading = props.loading !== undefined ? props.loading : (
    appManager.initializingApp || !userManager.loaded || !classroomManager.loaded
  );

  const {
    classroomProgressData, selectedContentType
  } = studentProgressManager;

  const ProgressBar = SatCoreComponent('ProgressBar');

  const courseProgressLabel = t('CourseProgressLabel', 'Missing course progress label translation');

  const innerWidgetContent = (
    <div className='courses' tabIndex={-1}>
      {(classroomProgressData.courses.length > 0) ?
        classroomProgressData.courses.map((course) => {
          let inProgressChapters = course?.inProgressChapters || 0;
          let totalChapters = course?.totalChapters || 0;

          if (selectedContentType === 'ExperTrack') {
            inProgressChapters = course.experTrackInProgressChapters || 0;
            totalChapters = course.experTrackTotalChapters || 0;
          } else if (selectedContentType === 'Clickbook') {
            inProgressChapters = course.clickbookInProgressChapters || 0;
            totalChapters = course.clickbookTotalChapters || 0;
          }
          return (
            <div key={course.courseId} className='course-progress' tabIndex={0}>
              <Popup
                content={<div className='course-name'>{course.courseName}</div>}
                trigger={<div className='course-name'>{course.courseName}</div>} />
              <div className='progress'>
                <span>
                  {inProgressChapters}
                  /
                  {totalChapters}
                </span>
                {' '}
                {t('chaptersTitle', 'Chapters In Progress or Complete')}
              </div>
              <div className='progress-bar'>
                <ProgressBar
                  progress={inProgressChapters}
                  total={totalChapters} />
              </div>
            </div>
          );
        }) : (
          <div className='center no-scores'>
            {!loading && <p>{t('noScoresYet', 'No scores yet')}</p>}
          </div>
        )}
    </div>
  );
  return !onlyRenderInnerWidgetContent ? (
    <div className='StudentProgressBarWidget StudentProgressWidget widget progress-widget' tabIndex='0'>
      <h2 aria-label={`${courseProgressLabel}:`} className='w-title'>{courseProgressLabel}</h2>
      {innerWidgetContent}
    </div>
  ) : innerWidgetContent;
});

export default StudentProgressBarWidget;

SatCoreRegister('StudentProgressBarWidget', StudentProgressBarWidget);
